import React, { HTMLAttributes } from "react";
import { FloatingComponentDataModel, FloatingComponentTypename } from "../types";
import { FloatingComponentsMap } from "./map";


type FloatingComponentProps = {
    parentTypename: string;
    data: FloatingComponentDataModel;
    ContainerProps?: HTMLAttributes<HTMLDivElement>;
    forceDesktop?: boolean;
};

export const FloatingComponent = (props: FloatingComponentProps) => {
    const { data, parentTypename } = props;

    const typename = data.__typename.replace(parentTypename, '') as FloatingComponentTypename;
    const Component = FloatingComponentsMap[typename] || null;

    return Component ? (
        // <div {...props.ContainerProps}>
            <React.Suspense>
                <Component data={data} ContainerProps={props.ContainerProps} forceDesktop={props.forceDesktop} />
            </React.Suspense>
        // </div>
    ) : null
};
